import { render, staticRenderFns } from "./AppAuthenticationSignup.vue?vue&type=template&id=4bb2abbe&scoped=true&"
import script from "./AppAuthenticationSignup.vue?vue&type=script&lang=ts&"
export * from "./AppAuthenticationSignup.vue?vue&type=script&lang=ts&"
import style0 from "./AppAuthenticationSignup.vue?vue&type=style&index=0&id=4bb2abbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2abbe",
  null
  
)

export default component.exports